import {InputLabel, Select as MUISelect, SelectProps as MUISelectProps} from '@mui/material'
import FormControl from '@mui/material/FormControl'
import {SelectChangeEvent as MUISelectChangeEvent, SelectInputProps as MUISelectInputProps} from '@mui/material/Select/SelectInput'
import React, {ReactNode, useId} from 'react'
import {INPUT_WIDTH} from './utils'

export type SelectChangeEvent<T> = MUISelectChangeEvent<T>
export type SelectInputProps<T> = MUISelectInputProps<T>

// To be able to keep the public API after upgrade to @mui/material@^6.4.6':
// Allow `placeholder` even though MUI Select doesn't have it.
export type SelectProps<T> = MUISelectProps<T> & {
  placeholder?: ReactNode
}

export const Select = <T extends {}>({label, placeholder = '', value, id, multiple, ...rest}: SelectProps<T>): ReactNode => {
  const autoId = useId()
  const labelId = id ? `${id}-label` : `${autoId}-label`

  // normalize controlled value
  const normalizedValue = value !== undefined ? (value as any) : multiple ? [] : ''

  const isEmpty =
    (multiple && Array.isArray(normalizedValue) && normalizedValue.length === 0) || (!multiple && (normalizedValue === '' || normalizedValue == null))

  return (
    <FormControl sx={{minWidth: INPUT_WIDTH}}>
      {label ? <InputLabel id={labelId}>{label}</InputLabel> : null}
      <MUISelect
        // only wire label props when label exists
        {...(label ? {labelId, label} : {})}
        id={id}
        variant="standard"
        value={normalizedValue}
        displayEmpty
        // Only override renderValue when empty (to show placeholder)
        {...(isEmpty
          ? {
              renderValue: () => <span style={{opacity: 0.6}}>{placeholder}</span>,
            }
          : {})}
        {...rest}
      />
    </FormControl>
  )
}
